(function(){
"use strict";
var DATA = JSON.parse(document.getElementById('bb-data').textContent);
var CFG = DATA.cfg;
var R = "₹";
var $ = function(id){ return document.getElementById(id); };

/* ---- catalogue: merge collection feeds, union categories, keep frontpage rank ---- */
var byPid = {};
DATA.items.forEach(function(it){
  var e = byPid[it.pid];
  if (!e){ e = byPid[it.pid] = { pid:it.pid, id:String(it.id), h:it.h, t:it.t, v:(it.v==='Default Title'?'':it.v), p:it.p, av:it.av, iq:it.iq, im:it.im, cq:it.cq||'', cats:{}, rank:9999 }; }
  if (it.cat === 'rank'){ e.rank = it.rank; } else { e.cats[it.cat] = true; }
});
var PRODUCTS = Object.keys(byPid).map(function(k){ return byPid[k]; });
PRODUCTS.sort(function(a,b){ return a.rank - b.rank || (a.t < b.t ? -1 : 1); });
var byId = {}; PRODUCTS.forEach(function(p){ byId[p.id] = p; });

var CATS = [ {k:'all',l:'All'}, {k:'veg',l:'Veg'}, {k:'fruits',l:'Fruits'}, {k:'exotics',l:'Exotics'}, {k:'pantry',l:'Pantry'} ];
var CAT_FULL = { all:'Everything at Beybey', veg:'Vegetables', fruits:'Fruits', exotics:'Exotics', pantry:'Pantry' };
var SYN = { 'bhindi':'okra','lauki':'bottle gourd','dhaniya':'coriander','palak':'spinach','nimbu':'lemon','shimla mirch':'capsicum','shimla':'capsicum','anar':'pomegranate','tamatar':'tomato','kheera':'cucumber','gajar':'carrot','gobhi':'cauliflower','mosambi':'mausambi','mousambi':'mausambi' };

/* ---- state ---- */
var LS = { cart:'bb_cart_v1', addr:'bb_addr_v1', usuals:'bb_usuals_v1', ret:'bb_returning_v1' };
function lsGet(k,f){ try{ var v = localStorage.getItem(k); return v ? JSON.parse(v) : f; }catch(e){ return f; } }
function lsSet(k,v){ try{ localStorage.setItem(k, JSON.stringify(v)); }catch(e){} }
var SERVER_USUALS = [];
(DATA.usuals || []).forEach(function(pid){ var e = byPid[pid]; if (e && SERVER_USUALS.indexOf(e.id) < 0) SERVER_USUALS.push(e.id); });
var state = {
  cart: lsGet(LS.cart, {}),          /* variantId -> qty */
  category: 'all',
  query: '',
  addr: lsGet(LS.addr, null),
  usuals: SERVER_USUALS.length ? SERVER_USUALS : lsGet(LS.usuals, []),
  returning: SERVER_USUALS.length > 0 || CFG.logged_in || !!lsGet(LS.ret, false),
  payMethod: 'upi',
  notices: [],
  ordersApi: null,                    /* health-checked base URL or null */
  fees: { freeDeliveryThreshold:499, deliveryFee:30, packagingFee:8, codFee:9 },
  lastOrder: null
};
Object.keys(state.cart).forEach(function(id){ if (!byId[id]) delete state.cart[id]; });

/* ---- analytics (lean, canonical product_add) ---- */
window.dataLayer = window.dataLayer || [];
function track(ev, props){
  var p = props || {};
  p.event = ev;
  p.customer_type = state.returning ? 'returning' : 'new';
  p.city = CFG.city;
  p.cart_items = cartCount();
  p.cart_value = Math.round(cartTotal()/100);
  window.dataLayer.push(p);
}

/* ---- helpers ---- */
function rup(paise){ return R + (Math.round(paise)/100).toLocaleString('en-IN', {maximumFractionDigits: (paise % 100 ? 2 : 0)}); }
function cartCount(){ var n=0; for (var k in state.cart) n += state.cart[k]; return n; }
function cartTotal(){ var t=0; for (var k in state.cart) t += state.cart[k]*(byId[k]?byId[k].p:0); return t; }
/* addCtl() only ever renders an add/stepper control when p.av is true, so by the time
   setQty() calls this the product is already known-sellable per Shopify. iq<=0 alongside
   av:true means the variant is on a "continue selling when out of stock" policy, not a real
   zero-stock block -- treat it the same as untracked inventory (uncapped) rather than
   silently capping the cart at 0, which made ADD do nothing with no feedback. */
function maxQty(p){ return (p.iq === null || p.iq === undefined || p.iq <= 0) ? 99 : p.iq; }
function saveCart(){ lsSet(LS.cart, state.cart); }

/* ---- order window (real, configurable; rolls to next window, never 00:00) ---- */
function windowInfo(){
  var now = new Date();
  var cutoff = new Date(now); cutoff.setHours(CFG.cutoff_hour, 0, 0, 0);
  if (now >= cutoff){ cutoff.setDate(cutoff.getDate() + 1); }
  var mins = Math.max(1, Math.round((cutoff - now)/60000));
  var h = Math.floor(mins/60), m = mins%60;
  var left = (h>0 ? h + 'h ' : '') + m + 'm';
  return { left:left, label:CFG.window_label, short:CFG.window_short };
}
function renderWindow(){
  var w = windowInfo();
  $('bbWindow').textContent = 'Order window closes in ' + w.left;
  $('bbWindowMini').textContent = 'Closes in ' + w.left;
}
setInterval(renderWindow, 30000);

/* ---- controls ---- */
function addCtl(id, cls){
  var p = byId[id]; if (!p) return '';
  var q = state.cart[id] || 0;
  if (!p.av) return '';
  var k = ' data-ctl-id="'+id+'" data-ctl-cls="'+cls+'"';
  if (cls === 'grid'){
    if (!q) return '<button class="bb-gadd"'+k+' data-add="'+id+'" data-src="grid">+ ADD</button>';
    return '<div class="bb-gstep"'+k+'><button data-dec="'+id+'" aria-label="Reduce quantity">&minus;</button><b aria-live="polite">'+q+'</b><button data-inc="'+id+'" aria-label="Increase quantity">+</button></div>';
  }
  if (cls === 'search'){
    if (!q) return '<button class="bb-sadd"'+k+' data-add="'+id+'" data-src="search">+ ADD</button>';
    return '<div class="bb-sstep"'+k+'><button data-dec="'+id+'" aria-label="Reduce quantity">&minus;</button><b>'+q+'</b><button data-inc="'+id+'" aria-label="Increase quantity">+</button></div>';
  }
  if (cls === 'mini'){
    if (!q) return '<button class="bb-mini"'+k+' data-add="'+id+'" data-src="buy_again" aria-label="Add">+</button>';
    return '<div class="bb-ministep"'+k+'><button data-dec="'+id+'" aria-label="Reduce quantity">&minus;</button><b>'+q+'</b><button data-inc="'+id+'" aria-label="Increase quantity">+</button></div>';
  }
  if (cls === 'shelf-farm' || cls === 'shelf-popular'){
    var src = cls === 'shelf-farm' ? 'from_farm' : 'popular_near_you';
    if (!q) return '<button class="bb-shelfadd"'+k+' data-add="'+id+'" data-src="'+src+'">+ ADD</button>';
    return '<div class="bb-shelfstep"'+k+'><button data-dec="'+id+'" aria-label="Reduce quantity">&minus;</button><b aria-live="polite">'+q+'</b><button data-inc="'+id+'" aria-label="Increase quantity">+</button></div>';
  }
  if (cls === 'hero'){
    if (!q) return '<button class="hcta-btn"'+k+' data-add="'+id+'" data-src="hero">ADD TO CART &rarr;</button>';
    return '<div class="hcta-step"'+k+'><button data-dec="'+id+'" aria-label="Reduce quantity">&minus;</button><b aria-live="polite">'+q+'</b><button data-inc="'+id+'" aria-label="Increase quantity">+</button></div>';
  }
  return '';
}
/* ---- targeted control refresh: cart-quantity changes only ever affect the
   add/stepper control itself (image, name, price, unit text are unaffected),
   so re-render just that element wherever it appears rather than rebuilding
   the entire grid/shelves -- avoids destroying and repainting every product
   image (with its drop-shadow filter) on every single tap. ---- */
function updateControls(id){
  document.querySelectorAll('[data-ctl-id="'+id+'"]').forEach(function(el){
    var cls = el.dataset.ctlCls;
    var html = addCtl(id, cls);
    if (html) el.outerHTML = html;
  });
}
function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

var CAT_ICONS = {
  all:'<svg width="24" height="24" viewBox="0 0 24 24" fill="FILL" aria-hidden="true"><rect x="2" y="2" width="9" height="9" rx="2"/><rect x="13" y="2" width="9" height="9" rx="2"/><rect x="2" y="13" width="9" height="9" rx="2"/><rect x="13" y="13" width="9" height="9" rx="2"/></svg>',
  veg:'<svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21c-3-5-3-11 1-16 3 5 2 12-1 16Z" fill="#357a2e" transform="rotate(-18 12 12)"/><path d="M12 21c-3-5-3-11 1-16 3 5 2 12-1 16Z" fill="#5cab45" transform="rotate(18 12 12)"/><path d="M12 21.5c-3-6-3-13 1-18.5 3 5 2 13-1 18.5Z" fill="#4a9d3f"/></svg>',
  fruits:'<svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13.5" r="9" fill="#e0a23f"/><ellipse cx="8.7" cy="10.2" rx="2.6" ry="1.7" fill="#eebd6c" opacity="0.65"/><path d="M11 4.2c-1-2 .8-3.7 2.9-3.7-.4 2-1.7 3.2-2.9 3.7Z" fill="#4a9d3f"/></svg>',
  exotics:'<svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2c4.6 4.2 6.6 9.2 6.6 13.2a6.6 6.6 0 0 1-13.2 0C5.4 11.2 7.4 6.2 12 2Z" fill="#3d5f2a"/><path d="M12 6.3c3 3.3 4.6 6.9 4.6 9.4a4.6 4.6 0 0 1-9.2 0c0-2.5 1.6-6.1 4.6-9.4Z" fill="#dde6ae"/><ellipse cx="12" cy="16.6" rx="2.5" ry="3" fill="#8b6b3d"/></svg>',
  pantry:'<svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 8.6c0-1.7 1.2-2.8 2.3-3.9 1.7 1.1 3.7 1.1 5.4 0 1.1 1.1 2.3 2.2 2.3 3.9V19a2 2 0 0 1-2 2H8.5a2 2 0 0 1-2-2Z" fill="#cda155"/><rect x="6.8" y="13.2" width="10.4" height="2.8" fill="#a9793a" opacity="0.55"/><path d="M8.2 5.3c1.6 1.4 3.2 1.4 4.8 0M11.6 5.3c1.6 1.4 3.2 1.4 4.8 0" stroke="#8a642e" stroke-width="1" fill="none" stroke-linecap="round"/></svg>'
};

var CAT_IMG = DATA.catImg || {};
var CAT_PORTRAIT = DATA.catPortrait || {};
function catVisual(k, on){
  if (k === 'all'){
    var imgs = (CAT_IMG.all || []).filter(Boolean).slice(0,4);
    if (imgs.length){
      return '<span class="ic ic-collage">' + imgs.map(function(u){ return '<img src="'+esc(u)+'" alt="" loading="lazy">'; }).join('') + '</span>';
    }
    return '<span class="ic">' + CAT_ICONS.all.replace('FILL', on ? '#63AD3E' : '#9aa89a') + '</span>';
  }
  var url = CAT_IMG[k];
  if (url) return '<span class="ic"><img src="'+esc(url)+'" alt="" loading="lazy"></span>';
  return '<span class="ic">' + CAT_ICONS[k] + '</span>'; /* graceful fallback: no product image configured/available */
}
function renderRail(){
  var el = $('bbRail');
  if (!el) return; /* top rail removed from Home; catalogue nav (below) now owns category selection — kept for reuse, not deleted */
  el.innerHTML = CATS.map(function(c){
    var on = state.category === c.k;
    return '<button class="bb-cat'+(on?' on':'')+'" data-cat="'+c.k+'" role="tab" aria-selected="'+on+'">'+
      catVisual(c.k, on)+'<span class="lb">'+c.l+'</span><span class="ub"></span></button>';
  }).join('');
}

/* ---- catalogue-mode navigation: sticky horizontal strip on mobile/tablet,
   persistent vertical rail on desktop (pure CSS via position:sticky — no
   scroll listener). Reuses the same CATS + selectCategory() as the
   discovery rail above: one filtering system, two presentations. ---- */
function catNavHtml(){
  return CATS.map(function(c){
    var on = state.category === c.k;
    var label = c.k === 'all' ? 'All' : CAT_FULL[c.k];
    return '<button class="bb-catnav-item'+(on?' on':'')+'" data-cat="'+c.k+'" role="tab" aria-selected="'+on+'"><span class="ind" aria-hidden="true"></span><span>'+esc(label)+'</span></button>';
  }).join('');
}
function renderCatNav(){
  var el = $('bbCatNav');
  if (el) el.innerHTML = catNavHtml();
}

/* ---- hero (configuration-driven) ---- */
function heroHtml(){
  var h = DATA.hero;
  if (!h.active || !h.headline) return '';
  var cta;
  if (h.type === 'single' && h.vid && h.available && h.handle){
    /* Transactional CTA: reuses the same setQty()/byId cart system as every
       other Add control, keyed by the hero's real live variant id — so the
       hero, catalogue card, and cart count always read one shared state. */
    cta = addCtl(String(h.vid), 'hero');
    if (!cta) return '';
  } else if (h.type === 'collection' && h.collection){
    cta = '<button class="hcta-btn" data-herocol="'+esc(h.collection)+'">SHOP COLLECTION &rarr;</button>';
  } else {
    return '';
  }
  return '<div class="bb-hero acc-'+esc(h.accent)+'">'+
    (h.image ? '<img src="'+esc(h.image)+'" alt="" loading="eager">' : '')+
    '<div class="hin"><h1>'+h.headline.split('\n').map(esc).join('<br>')+'</h1>'+
    '<div class="usp">'+esc(h.usp||'')+'</div><div class="hcta">'+cta+'</div></div></div>';
}

/* ---- Beybey promise strip (site-level operational copy, not per-SKU claims) ---- */
function promiseHtml(){
  var items = [
    { t:'Harvested before delivery', s:'We don’t store. We harvest.' },
    { t:'Ozone washed', s:'Cleaned with care.' },
    { t:'No shortcuts', s:'Only clean, honest food.' },
    { t:'Delivered fresh', s:'On your table.' }
  ];
  return '<div class="bb-promise">'+items.map(function(it){
    return '<div class="bb-pcell"><b>'+esc(it.t)+'</b><span>'+esc(it.s)+'</span></div>';
  }).join('')+'</div>';
}

/* ---- From Beybey Farms: shoppable rail, restricted to the existing Grown
   classification source (vegetables-collection membership — the only such
   signal present in the current data model; no separate Grown flag exists) ---- */
function harvestHtml(){
  var items = PRODUCTS.filter(function(p){ return p.av && p.cats.veg; }).slice(0,8);
  if (!items.length) return '';
  return '<div class="bb-section bb-section-cream"><div class="bb-shelf-h"><b>From Beybey Farms</b><span>Grown close to home.</span></div><div class="bb-hrail">'+
    items.map(function(p){
      return '<article class="bb-round"><a class="bb-round-product" href="/products/'+esc(p.h)+'"><span class="rimg"><img src="'+esc(p.im)+'" alt="'+esc(p.t)+'" loading="lazy"></span><span class="rn">'+esc(p.t)+'</span></a>'+
        '<div class="bb-shelfbuy"><span class="bb-shelfprice">'+rup(p.p)+'</span>'+addCtl(p.id,'shelf-farm')+'</div></article>';
    }).join('')+'</div></div>';
}

/* ---- Shop by category: four category portraits, each a cluster of real
   products from that live collection (not one lonely product) ---- */
function shopCatHtml(){
  var cats = [
    { k:'veg', t:'Vegetables', s:'Fresh & leafy greens' },
    { k:'fruits', t:'Fruits', s:'Farm fresh & handpicked' },
    { k:'exotics', t:'Exotics', s:'Unique picks, just for you' },
    { k:'pantry', t:'Pantry', s:'Grains, pulses & more' }
  ];
  return '<div class="bb-shelf-h"><b>Shop by category</b></div><div class="bb-shopcat">'+
    cats.map(function(c){
      /* editorial tile: one clean representative image per category, never
         an overlapping collage — CAT_PORTRAIT (multi-image cluster) is kept
         in the data feed for potential reuse elsewhere but intentionally
         unused here */
      var media = CAT_IMG[c.k] ? '<img src="'+esc(CAT_IMG[c.k])+'" alt="" loading="lazy">' : '';
      return '<button class="bb-catcard" data-cat="'+c.k+'">'+media+
        '<span class="cin"><b>'+esc(c.t)+'</b><span>'+esc(c.s)+'</span></span>'+
        '<span class="arr" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="'+ '#1c2b1f' +'" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></span></button>';
    }).join('')+'</div>';
}

/* ---- shelves (personalised order; no fake data) ---- */
function shelfBuyAgain(){
  var ids = state.usuals.filter(function(id){ return byId[id] && byId[id].av; }).slice(0,4);
  if (!ids.length) return '';
  return '<div class="bb-shelf-h"><b>Buy again</b><span>Your usuals</span></div><div class="bb-hrail">'+
    ids.map(function(id){ var p = byId[id];
      return '<div class="bb-pill"><img src="'+esc(p.im)+'" alt="" loading="lazy"><span><span class="pn">'+esc(p.t)+'</span><br><span class="pp">'+rup(p.p)+'</span></span>'+addCtl(id,'mini')+'</div>';
    }).join('')+'</div>';
}
function shelfPopular(){
  var pids = DATA.popular;
  var items = [];
  pids.forEach(function(pid){ var e = byPid[pid]; if (e && e.av) items.push(e); });
  if (!items.length) items = PRODUCTS.filter(function(p){ return p.av; }).slice(0,5);
  items = items.slice(0,5);
  if (!items.length) return '';
  var compactCls = items.length <= 3 ? ' compact' : '';
  return '<div class="bb-section bb-section-pale'+compactCls+'"><div class="bb-shelf-h"><b>Popular at Beybey</b><span>Loved across the catalogue</span></div><div class="bb-hrail">'+
    items.map(function(p){
      return '<article class="bb-pop"><a class="bb-pop-product" href="/products/'+esc(p.h)+'"><span class="ph"><img src="'+esc(p.im)+'" alt="'+esc(p.t)+'" loading="lazy"></span><span class="pn">'+esc(p.t)+'</span></a>'+
        '<div class="bb-shelfbuy"><span class="bb-shelfprice">'+rup(p.p)+'</span>'+addCtl(p.id,'shelf-popular')+'</div></article>';
    }).join('')+'</div></div>';
}
function renderShelves(){
  var parts = [heroHtml(), promiseHtml(), harvestHtml()];
  if (state.returning) parts.push(shelfBuyAgain(), shelfPopular());
  else parts.push(shelfPopular());
  parts.push(shopCatHtml());
  $('bbShelves').innerHTML = parts.join('');
}

/* ---- grid + unavailable (single catalogue renderer — always visible from
   initial Home load; category taps filter it in place, they never hide it) ---- */
function visibleProducts(){
  var list = state.category === 'all' ? PRODUCTS : PRODUCTS.filter(function(p){ return p.cats[state.category]; });
  return list;
}
/* truthful "Grown" signal — vegetables-collection membership is the only
   classification source that exists in the data model; nothing invented */
function provenanceMark(p){
  if (!p.cats.veg) return '';
  return '<span class="bb-mark bb-mark-grown"><span class="dot"></span>Grown</span>';
}
/* quantity/unit label: a real variant name (e.g. "1 Pc") takes priority;
   most products are single-variant ("Default Title") and carry the quantity
   in the custom_quantity metafield instead, sometimes with marketing copy
   appended after a "|" (e.g. "1 Kg | Sweet & Juicy") — take only the
   quantity portion, and only if it actually looks like one (has a digit),
   so stray metafield values with no quantity never render as a fake unit */
function quantityLabel(p){
  if (p.v) return p.v;
  if (p.cq){
    var first = p.cq.split('|')[0].trim();
    if (/\d/.test(first)) return first;
  }
  return '';
}
function renderGrid(){
  var list = visibleProducts();
  var avail = list.filter(function(p){ return p.av; });
  var un = list.filter(function(p){ return !p.av; });
  $('bbCatTitle').textContent = CAT_FULL[state.category] || 'Everything at Beybey';
  $('bbCatCount').innerHTML = '<span class="bb-season-dot" aria-hidden="true"></span>' + avail.length + ' available today';

  var cards = avail.map(function(p, i){
    var unitText = quantityLabel(p);
    var lowText = (p.iq !== null && p.iq > 0 && p.iq <= 2) ? 'Only '+p.iq+' left' : '';
    var psHtml = '';
    if (unitText && lowText) psHtml = esc(unitText) + ' <span class="low">&middot; ' + esc(lowText) + '</span>';
    else if (unitText) psHtml = esc(unitText);
    else if (lowText) psHtml = '<span class="low">' + esc(lowText) + '</span>';
    return '<div class="bb-gcard"><div class="ph"><img src="'+esc(p.im)+'" alt="'+esc(p.t)+'" loading="'+(i<6?'eager':'lazy')+'" width="120" height="110"></div>'+
      provenanceMark(p)+
      '<div class="pn">'+esc(p.t)+'</div><div class="ps">'+psHtml+'</div>'+
      '<div class="pricerow"><span class="pp">'+rup(p.p)+'</span>'+addCtl(p.id,'grid')+'</div></div>';
  });
  $('bbGrid').innerHTML = cards.join('');

  var ub = $('bbUnavail');
  if (un.length){
    ub.hidden = false;
    $('bbUnavailTxt').textContent = 'Unavailable today (' + un.length + ')';
    $('bbUnavailList').innerHTML = un.map(function(p){
      return '<span class="uitem"><span>'+esc(p.t)+'</span><a href="/products/'+esc(p.h)+'" target="_blank" rel="noopener">Notify me</a></span>';
    }).join('');
  } else { ub.hidden = true; }
}

/* ---- cart bar / sheet ---- */
function renderCartBar(){
  var n = cartCount(), bar = $('bbCartBar');
  if (n > 0){
    $('bbCartTxt').textContent = n + (n===1?' item':' items') + ' · ' + rup(cartTotal());
    bar.classList.add('show');
  } else bar.classList.remove('show');
  var hc = $('bbHeaderCartCount');
  if (hc){
    if (hc.textContent !== String(n) && n > 0){
      hc.classList.remove('pulse'); void hc.offsetWidth; hc.classList.add('pulse');
    }
    hc.hidden = n <= 0; hc.textContent = n;
  }
}
function deliveryFeeInfo(sub){
  /* Mirrors the store's live shipping rates: tier1 below delivery_tier2_min, tier2 up to
     free_delivery_min, free above it. Values come from the section's theme settings. */
  var free = CFG.free_delivery_min != null ? CFG.free_delivery_min : 499;
  var t2min = CFG.delivery_tier2_min != null ? CFG.delivery_tier2_min : 249;
  var t2fee = CFG.delivery_fee_tier2 != null ? CFG.delivery_fee_tier2 : 19;
  var t1fee = CFG.delivery_fee_tier1 != null ? CFG.delivery_fee_tier1 : 30;
  if (sub >= free) return { fee:0, free:free, t2min:t2min, t2fee:t2fee };
  if (sub >= t2min) return { fee:t2fee, free:free, t2min:t2min, t2fee:t2fee };
  return { fee:t1fee, free:free, t2min:t2min, t2fee:t2fee };
}
function shopifyDelivery(){ return deliveryFeeInfo(cartTotal()/100).fee; }
function shopifyPackaging(){ return CFG.packaging_fee != null ? CFG.packaging_fee : 8; }
function shopifyExtras(){ return shopifyDelivery() + shopifyPackaging(); }
function deliveryNudge(sub){
  var di = deliveryFeeInfo(sub);
  if (sub >= di.free) return 'FREE delivery unlocked ✓';
  if (sub >= di.t2min) return 'Add ' + rup(Math.ceil(di.free - sub)*100) + ' more for FREE delivery.';
  return 'Add ' + rup(Math.ceil(di.t2min - sub)*100) + ' more to reduce delivery to ' + rup(di.t2fee*100) + '.';
}
function feesFor(method){
  var sub = cartTotal()/100, f = state.fees;
  if (!state.ordersApi) return null; /* fallback path: Shopify checkout adds delivery per config */
  return {
    delivery: sub >= f.freeDeliveryThreshold ? 0 : f.deliveryFee,
    packaging: f.packagingFee,
    cod: method === 'cod' ? f.codFee : 0
  };
}
function orderTotalPaise(method){
  var t = cartTotal(), f = feesFor(method);
  if (f) t += (f.delivery + f.packaging + f.cod) * 100;
  return t;
}
function totalsHtml(method){
  var f = feesFor(method);
  var rows = '<div class="bb-trow"><span>Items</span><b>'+rup(cartTotal())+'</b></div>';
  if (f){
    rows += '<div class="bb-trow'+(f.delivery===0?' free':'')+'"><span>Delivery</span><b>'+(f.delivery===0?'Free':rup(f.delivery*100))+'</b></div>';
    rows += '<div class="bb-trow"><span>Packaging</span><b>'+rup(f.packaging*100)+'</b></div>';
    if (f.cod) rows += '<div class="bb-trow"><span>COD fee</span><b>'+rup(f.cod*100)+'</b></div>';
    rows += '<div class="bb-trow total"><span>Total</span><b>'+rup(orderTotalPaise(method))+'</b></div>';
  } else {
    var sub = cartTotal()/100, del = shopifyDelivery(), pack = shopifyPackaging();
    rows += '<div class="bb-trow'+(del===0?' free':'')+'"><span>Delivery</span><b>'+(del===0?'Free':rup(del*100))+'</b></div>';
    rows += '<div class="bb-trow"><span>Packaging &amp; forwarding</span><b>'+rup(pack*100)+'</b></div>';
    rows += '<div class="bb-nudge'+(del===0?' unlocked':'')+'">'+esc(deliveryNudge(sub))+'</div>';
    rows += '<div class="bb-trow total"><span>Total</span><b>'+rup(cartTotal() + (del+pack)*100)+'</b></div>';
  }
  return rows;
}
function renderSheet(){
  var n = cartCount();
  $('bbSheetTitle').textContent = 'Your Beybey bag · ' + n + (n===1?' item':' items');
  var body = $('bbSheetBody'), cta = $('bbConfirmOpen');
  if (!n){
    body.innerHTML = '<div class="bb-empty">Your cart is empty.<br>Add something delicious.</div>';
    cta.disabled = true; cta.textContent = 'CONFIRM & PAY'; return;
  }
  cta.disabled = false;
  var rows = Object.keys(state.cart).map(function(id){
    var p = byId[id], q = state.cart[id];
    return '<div class="bb-crow"><img src="'+esc(p.im)+'" alt="" loading="lazy"><div class="ci"><div class="pn">'+esc(p.t)+'</div><div class="ps">'+esc(p.v||'')+(p.v?' · ':'')+rup(p.p)+'</div></div>'+
      '<div class="bb-ministep"><button data-dec="'+id+'" aria-label="Reduce">&minus;</button><b>'+q+'</b><button data-inc="'+id+'" aria-label="More">+</button></div></div>';
  }).join('');
  var notices = state.notices.map(function(nt){ return '<div class="bb-notice">'+esc(nt)+'</div>'; }).join('');
  var forgotIds = PRODUCTS.filter(function(p){ return p.av && !state.cart[p.id] && p.p <= 10000; }).slice(0,3);
  var forgot = forgotIds.length
    ? '<div class="bb-forgot-h">FORGOT SOMETHING?</div><div class="bb-fchips">'+forgotIds.map(function(p){
        return '<button class="bb-fchip" data-add="'+p.id+'" data-src="cart_quick_add">'+esc(p.t)+' '+rup(p.p)+' +</button>';
      }).join('')+'</div>' : '';
  body.innerHTML = notices + rows + forgot +
    '<div class="bb-totals">'+totalsHtml('upi')+'</div>'+
    '<div class="bb-reassure"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#4d8730" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:none;" aria-hidden="true"><path d="M12 22v-9"/><path d="M12 13C12 8 8 6 4 6c0 5 3 8 8 8Z"/><path d="M12 13c0-3.5 2.5-5 6-5 0 4-2.5 6-6 6"/></svg><span>Freshness, planned closer to delivery.</span></div><div style="height:14px;"></div>';
  cta.textContent = 'CONFIRM & PAY ' + rup(state.ordersApi ? orderTotalPaise('upi') : cartTotal() + shopifyExtras()*100);
}

/* ---- search ---- */
function renderSearch(){
  var q = state.query.trim().toLowerCase(), body = $('bbSearchBody');
  if (!q){
    var trending = PRODUCTS.filter(function(p){ return p.av; }).slice(0,6);
    body.innerHTML = '<div class="bb-strend">TRENDING IN '+esc(CFG.city).toUpperCase()+'</div><div class="bb-schips">'+
      trending.map(function(p){ return '<button class="bb-schip" data-q="'+esc(p.t.toLowerCase())+'">'+esc(p.t.toLowerCase())+'</button>'; }).join('')+'</div>'+
      '<div class="bb-sempty">Hindi works too — bhindi, lauki, dhaniya, shimla mirch, anar…</div>';
    return;
  }
  var target = q, syn = '';
  for (var s in SYN){
    if (q === s || (s.indexOf(q) === 0 && q.length >= 3)){
      target = SYN[s];
      syn = '<div class="bb-syn">Showing "'+esc(q)+'" as '+esc(target.charAt(0).toUpperCase()+target.slice(1))+'</div>';
      break;
    }
  }
  var hits = PRODUCTS.filter(function(p){
    var t = p.t.toLowerCase();
    return t.indexOf(target) >= 0 || t.indexOf(q) >= 0;
  });
  var avail = hits.filter(function(p){ return p.av; });
  var un = hits.filter(function(p){ return !p.av; });
  if (!avail.length && !un.length){
    track('search_no_results', { query: q });
    body.innerHTML = syn + '<div class="bb-sempty">Couldn’t find that one. Try another search?</div>';
    return;
  }
  if (!avail.length && un.length){
    body.innerHTML = syn + '<div class="bb-sempty">'+esc(un[0].t)+' is not available today — it comes and goes with the season. <a href="/products/'+esc(un[0].h)+'" style="color:var(--teal-deep);font-weight:700;">Get notified</a>.</div>';
    return;
  }
  body.innerHTML = syn + avail.map(function(p){
    return '<div class="bb-srow"><img src="'+esc(p.im)+'" alt="" loading="lazy"><div class="si"><div class="pn">'+esc(p.t)+'</div><div class="ps">'+esc(p.v||'')+'</div><div class="pp">'+rup(p.p)+'</div></div>'+addCtl(p.id,'search')+'</div>';
  }).join('') + (un.length ? '<div class="bb-sempty" style="padding-top:8px;">Also matched but unavailable today: '+un.map(function(p){return esc(p.t);}).join(', ')+'</div>' : '');
}

/* ---- render root ---- */
function renderAll(){
  renderRail(); renderShelves(); renderCatNav(); renderGrid(); renderCartBar(); renderWindow();
  if ($('bbSheet').classList.contains('show')) renderSheet();
  if ($('bbSearchOv').classList.contains('show')) renderSearch();
}

/* ---- toast (brief, truthful add-to-cart confirmation) ---- */
var toastTimer = null;
function showToast(msg){
  var el = $('bbToast'); if (!el) return;
  el.textContent = msg;
  el.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function(){ el.classList.remove('show'); }, 1800);
}

/* ---- cart ops (optimistic; caps at sellable qty) ---- */
function setQty(id, q, src){
  var p = byId[id]; if (!p) return;
  var cap = maxQty(p);
  if (q > cap){ q = cap; if (cap > 0) state.notices = ['Only '+cap+' of '+p.t+' available today.']; }
  var prev = state.cart[id] || 0;
  if (q <= 0) delete state.cart[id]; else state.cart[id] = q;
  saveCart();
  if (q > prev){
    track('product_add', { product_id: p.pid, variant_id: p.id, qty: q - prev, price: p.p/100, source: src || 'grid' });
    showToast(p.cats && p.cats.veg ? 'Added. We’ll harvest it fresh 🌱' : 'Added to your bag');
  }
  if (q < prev) track('product_remove', { product_id: p.pid, qty_after: q, source: src || 'grid' });
  updateControls(id); renderCartBar();
  if ($('bbSheet').classList.contains('show')) renderSheet();
  if ($('bbSearchOv').classList.contains('show')) renderSearch();
}

/* ---- revalidation against live storefront data (same-origin product .js) ---- */
function revalidateCart(){
  var ids = Object.keys(state.cart);
  if (!ids.length) return Promise.resolve(true);
  var handles = {};
  ids.forEach(function(id){ if (byId[id]) handles[byId[id].h] = true; });
  var notices = [];
  return Promise.all(Object.keys(handles).map(function(h){
    return fetch('/products/' + h + '.js').then(function(r){ return r.json(); }).then(function(pj){
      (pj.variants || []).forEach(function(v){
        var id = String(v.id), p = byId[id];
        if (!p || !state.cart[id]) return;
        if (v.price !== p.p){
          notices.push(p.t + ' price updated ' + rup(p.p) + ' → ' + rup(v.price));
          p.p = v.price;
        }
        if (!v.available){
          notices.push(p.t + ' is unavailable today — removed.');
          p.av = false; delete state.cart[id];
        } else if (typeof v.inventory_quantity === 'number' && v.inventory_management){
          p.iq = v.inventory_quantity;
          if (state.cart[id] > v.inventory_quantity && v.inventory_quantity > 0){
            notices.push(p.t + ' reduced to ' + v.inventory_quantity + ' (all we have today).');
            state.cart[id] = v.inventory_quantity;
          } else if (v.inventory_quantity <= 0){
            notices.push(p.t + ' just sold out — removed.');
            delete state.cart[id];
          }
        }
      });
    }).catch(function(){});
  })).then(function(){
    state.notices = notices;
    saveCart();
    return notices.length === 0;
  });
}

/* ---- orders API (custom checkout) health ---- */
(function(){
  var base = (CFG.orders_api || '').replace(/\/$/, '');
  if (!base) return;
  var ctl = new AbortController(); setTimeout(function(){ ctl.abort(); }, 4000);
  fetch(base + '/fees', { signal: ctl.signal }).then(function(r){ return r.json(); }).then(function(f){
    if (f && typeof f.deliveryFee === 'number'){ state.ordersApi = base; state.fees = f; }
  }).catch(function(){});
})();

/* ---- checkout flow ---- */
var PAY = [ {k:'upi', t1:'UPI', t2:'GPay · PhonePe · Paytm'}, {k:'card', t1:'Cards & Netbanking', t2:''} ];
function payMethods(){
  var m = PAY.slice();
  if (CFG.cod_enabled && state.ordersApi) m.push({k:'cod', t1:'Cash on Delivery', t2:'+' + rup(state.fees.codFee*100) + ' COD fee'});
  return m;
}
function renderConfirm(){
  var a = state.addr || {};
  var addrCard = $('cfName').closest('.bb-info');
  var addrLabel = addrCard.previousElementSibling;
  if (!state.ordersApi){
    /* Magic Checkout path: the payment method (including COD) is chosen on Razorpay Magic's own
       payment screen and cannot be preselected from the storefront (verified against
       magic-shopify.js: no method/COD prefill hook). So we list the real methods truthfully,
       without a duplicate selector, and keep the CTA method-neutral. */
    addrCard.style.display = 'none'; addrLabel.style.display = 'none';
    $('cfPayOpts').innerHTML =
      '<div class="bb-info" style="margin-top:0;"><div class="ii"><div class="t1">UPI &middot; Cards &middot; Netbanking</div><div class="t2">Secure checkout &middot; Razorpay</div></div></div>' +
      '<div class="bb-info" style="margin-top:10px;"><div class="ii"><div class="t1">Cash on Delivery</div><div class="t2">Pay when your order arrives &middot; no extra fee</div></div></div>' +
      '<div style="font-size:11.5px;color:var(--ink-soft);margin:10px 16px 0;">Choose your method on the next screen.</div>';
  } else {
    addrCard.style.display = ''; addrLabel.style.display = '';
    $('cfName').textContent = a.name ? a.name : 'Home';
    $('cfAddr').textContent = [a.house, a.area, (CFG.city + (a.pin ? ' – ' + a.pin : ''))].filter(Boolean).join(', ');
    $('cfPayOpts').innerHTML = payMethods().map(function(m){
      return '<button class="bb-pay'+(state.payMethod===m.k?' on':'')+'" data-pay="'+m.k+'"><span class="bb-radio"></span><span style="flex:1;"><span class="t1">'+m.t1+'</span>'+(m.t2?'<br><span class="t2">'+m.t2+'</span>':'')+'</span></button>';
    }).join('');
  }
  $('cfWindow').textContent = windowInfo().label;
  $('cfTotals').innerHTML = totalsHtml(state.payMethod);
  var pb = $('bbPayBtn');
  if (!state.ordersApi) pb.textContent = 'CONFIRM ORDER ' + rup(cartTotal() + shopifyExtras()*100) + ' →';
  else if (state.payMethod === 'cod') pb.textContent = 'CONFIRM ORDER ' + rup(orderTotalPaise('cod'));
  else pb.textContent = 'PAY ' + rup(orderTotalPaise(state.payMethod));
}
function serviceable(pin){
  var prefixes = (CFG.pin_prefixes || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  if (!prefixes.length) return true;
  return prefixes.some(function(pre){ return pin.indexOf(pre) === 0; });
}
function openConfirmFlow(){
  if (!cartCount()) return;
  track('confirm_pay_clicked', {});
  revalidateCart().then(function(clean){
    if (!cartCount()){ renderSheet(); return; }
    if (!clean){ renderSheet(); renderCartBar(); renderGrid(); return; }
    if (!state.ordersApi){
      /* Shopify-native: address + payment method are collected by Shopify checkout */
      renderConfirm(); $('bbConfirmOv').classList.add('show');
    } else if (state.addr && state.addr.pin && serviceable(state.addr.pin)){
      renderConfirm(); $('bbConfirmOv').classList.add('show');
    } else {
      openAddress();
    }
  });
}
function openAddress(){
  track('address_form_view', {});
  var a = state.addr || {};
  $('afPhone').value = a.phone || ''; $('afName').value = a.name || '';
  $('afHouse').value = a.house || ''; $('afArea').value = a.area || ''; $('afPin').value = a.pin || '';
  $('afErr').textContent = '';
  $('bbAddrOv').classList.add('show');
}
function saveAddress(){
  var phone = $('afPhone').value.replace(/\D/g,''), name = $('afName').value.trim(),
      house = $('afHouse').value.trim(), area = $('afArea').value.trim(), pin = $('afPin').value.replace(/\D/g,'');
  var err = '';
  if (phone.length !== 10) err = 'Enter a 10-digit mobile number.';
  else if (!name) err = 'Name helps the rider find you.';
  else if (!house || !area) err = 'House and area are needed to deliver.';
  else if (pin.length !== 6) err = 'Enter a 6-digit pincode.';
  else if (!serviceable(pin)) err = "We don't deliver to " + pin + " yet — Beybey currently serves " + CFG.city + ".";
  if (err){ $('afErr').textContent = err; return; }
  state.addr = { phone: phone, name: name, house: house, area: area, pin: pin };
  lsSet(LS.addr, state.addr);
  $('bbAddrOv').classList.remove('show');
  renderConfirm(); $('bbConfirmOv').classList.add('show');
}

var checkoutCtx = null; /* holds draft/rzp ids for the in-flight attempt */
function startPayment(){
  var method = state.payMethod;
  if (state.ordersApi) track('payment_started', { method: method, payment_type: method === 'cod' ? 'cod' : 'prepaid' });
  if (!state.ordersApi){
    /* Fallback: Shopify checkout permalink — existing production payment path */
    /* Sync the real Shopify cart, then trigger the native checkout control.
       Razorpay Magic Checkout (magic-shopify.js, rendered by the theme layout) intercepts
       [name=checkout] when live and opens the Magic overlay on OUR basket; if Magic is
       unavailable the same submit lands on standard Shopify checkout with identical contents. */
    track('payment_started', { payment_type: 'magic_checkout', methods_available: 'prepaid+cod' });
    showTeal('Opening secure checkout…', rup(cartTotal() + shopifyExtras()*100));
    var items = Object.keys(state.cart).map(function(id){ return { id: parseInt(id, 10), quantity: state.cart[id] }; });
    var note = 'Delivery window: ' + windowInfo().short + ' | via Beybey app';
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function(){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: items }) }); })
      .then(function(r){ if (!r.ok) throw new Error('cart add failed'); return fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ note: note }) }); })
      .then(function(){
        lsSet('bb_pending_sync', 1);
        hideTeal();
        var form = document.getElementById('bbNativeCheckout');
        if (form){ form.querySelector('[name="checkout"]').click(); }
        else { window.location.href = '/checkout'; }
      })
      .catch(function(){
        hideTeal();
        var parts = Object.keys(state.cart).map(function(id){ return id + ':' + state.cart[id]; });
        window.location.href = '/cart/' + parts.join(',') + '?note=' + encodeURIComponent(note);
      });
    return;
  }
  var items = Object.keys(state.cart).map(function(id){
    var p = byId[id];
    return { variantId: id, quantity: state.cart[id], price: (p.p/100).toFixed(2), title: p.t };
  });
  var customer = { phone: state.addr ? '+91' + state.addr.phone : '' };
  var shippingAddress = state.addr ? {
    firstName: state.addr.name.split(' ')[0], lastName: state.addr.name.split(' ').slice(1).join(' '),
    address1: state.addr.house, address2: state.addr.area, city: CFG.city, province: 'Madhya Pradesh',
    zip: state.addr.pin, country: 'India', phone: '+91' + state.addr.phone
  } : null;

  if (method === 'cod'){
    showTeal('Placing your order…', rup(orderTotalPaise('cod')));
    fetch(state.ordersApi + '/cod', { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items: items, customer: customer, shippingAddress: shippingAddress }) })
    .then(function(r){ return r.json(); })
    .then(function(d){
      if (d && d.success) return orderSucceeded(d.orderName, 'cod');
      throw new Error(d && d.error || 'COD failed');
    })
    .catch(function(){ hideTeal(); showFailure(); });
    return;
  }

  showTeal('Opening secure payment…', rup(orderTotalPaise(method)));
  loadRazorpay().then(function(){
    return fetch(state.ordersApi + '/checkout', { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items: items, customer: customer }) }).then(function(r){ return r.json(); });
  }).then(function(d){
    if (!d || !d.razorpayOrderId) throw new Error('checkout failed');
    checkoutCtx = d;
    hideTeal();
    var rz = new window.Razorpay({
      key: d.razorpayKeyId, amount: d.amount, currency: d.currency, order_id: d.razorpayOrderId,
      name: 'Beybey Farms', theme: { color: '#265563' },
      prefill: { contact: customer.phone },
      handler: function(resp){ verifyPayment(resp, shippingAddress); },
      modal: { ondismiss: function(){ track('payment_failed', { reason: 'dismissed', method: method }); showFailure(); } }
    });
    rz.on('payment.failed', function(resp){
      track('payment_failed', { reason: (resp.error && resp.error.reason) || 'failed', method: method });
    });
    rz.open();
  }).catch(function(){
    hideTeal();
    track('payment_failed', { reason: 'init_error', method: method });
    showFailure();
  });
}
function verifyPayment(resp, shippingAddress){
  showTeal('Checking your payment…', rup(orderTotalPaise(state.payMethod)));
  var body = {
    razorpayOrderId: resp.razorpay_order_id, razorpayPaymentId: resp.razorpay_payment_id,
    razorpaySignature: resp.razorpay_signature,
    shopifyDraftOrderId: checkoutCtx && checkoutCtx.shopifyDraftOrderId, shippingAddress: shippingAddress
  };
  var attempt = function(n){
    return fetch(state.ordersApi + '/verify-payment', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (d && d.success) return orderSucceeded(d.orderName, state.payMethod);
        throw new Error(d && d.error || 'verify failed');
      })
      .catch(function(e){
        if (n < 3) return new Promise(function(res){ setTimeout(res, 2500); }).then(function(){ return attempt(n+1); });
        /* payment likely captured but confirmation unknown — do NOT claim failure */
        hideTeal();
        $('bbFailOv').querySelector('.fmsg').textContent = "We're confirming your payment";
        $('bbFailOv').querySelector('.fsub').textContent = 'If money left your account, your order is safe — we’ll confirm it shortly. Your basket is also saved.';
        $('bbRetry').textContent = 'CHECK AGAIN';
        $('bbFailOv').classList.add('show');
        window.bbPendingVerify = function(){ $('bbFailOv').classList.remove('show'); verifyPayment(resp, shippingAddress); };
      });
  };
  attempt(0);
}
function orderSucceeded(orderName, method){
  var n = cartCount(), total = rup(orderTotalPaise(method));
  track('payment_success', { method: method, order_name: orderName, value: Math.round(orderTotalPaise(method)/100) });
  state.usuals = Object.keys(state.cart).concat(state.usuals.filter(function(id){ return !state.cart[id]; })).slice(0,6);
  lsSet(LS.usuals, state.usuals);
  state.returning = true; lsSet(LS.ret, true);
  state.cart = {}; saveCart(); state.notices = [];
  hideTeal();
  ['bbConfirmOv','bbAddrOv','bbFailOv'].forEach(function(id){ $(id).classList.remove('show'); });
  closeSheet();
  $('bbSuccSum').innerHTML = total + ' · ' + n + (n===1?' item':' items') + (orderName ? ' · ' + esc(orderName) : '') + '<br>' + esc(windowInfo().short);
  $('bbSuccOv').classList.add('show');
  renderAll();
}
function showFailure(){
  hideTeal();
  $('bbFailOv').querySelector('.fmsg').textContent = "Payment wasn't completed";
  $('bbFailOv').querySelector('.fsub').textContent = 'Your basket is still saved.';
  $('bbRetry').textContent = 'TRY AGAIN ' + rup(orderTotalPaise(state.payMethod));
  window.bbPendingVerify = null;
  $('bbFailOv').classList.add('show');
}
function showTeal(msg, amt){ $('bbTealMsg').textContent = msg; $('bbTealAmt').textContent = amt; $('bbTeal').classList.add('show'); }
function hideTeal(){ $('bbTeal').classList.remove('show'); }
var rzpLoading = null;
function loadRazorpay(){
  if (window.Razorpay) return Promise.resolve();
  if (rzpLoading) return rzpLoading;
  rzpLoading = new Promise(function(res, rej){
    var s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.onload = res; s.onerror = rej;
    document.head.appendChild(s);
  });
  return rzpLoading;
}

/* ---- sheet open/close ---- */
function openSheet(){ track('cart_opened', {}); renderSheet(); $('bbDim').classList.add('show'); $('bbSheet').classList.add('show'); }
function closeSheet(){ $('bbDim').classList.remove('show'); $('bbSheet').classList.remove('show'); }

/* ---- events (single delegate) ---- */
document.getElementById('bbApp').addEventListener('click', function(e){
  var t = e.target.closest('[data-add],[data-inc],[data-dec],[data-cat],[data-pay],[data-q],[data-herocol]');
  if (!t) return;
  if (t.dataset.add){ setQty(t.dataset.add, (state.cart[t.dataset.add]||0)+1, t.dataset.src); return; }
  if (t.dataset.inc){ setQty(t.dataset.inc, (state.cart[t.dataset.inc]||0)+1, 'stepper'); return; }
  if (t.dataset.dec){ setQty(t.dataset.dec, (state.cart[t.dataset.dec]||0)-1, 'stepper'); return; }
  if (t.dataset.cat){ selectCategory(t.dataset.cat); return; }
  if (t.dataset.herocol){ selectCategory(heroColCategory(t.dataset.herocol)); return; }
  if (t.dataset.pay){ state.payMethod = t.dataset.pay; renderConfirm(); return; }
  if (t.dataset.q){ state.query = t.dataset.q; $('bbSearchInput').value = t.dataset.q; track('search_started', {entry:'chip'}); renderSearch(); return; }
});
function heroColCategory(handle){
  var map = { 'vegetables':'veg', 'fruits':'fruits', 'exotics':'exotics', 'grains-pulses':'pantry' };
  return map[handle] || 'all';
}
function selectCategory(cat){
  state.category = cat;
  track('category_filter', { category: cat, from_sticky: $('bbSticky').classList.contains('show') });
  renderRail(); renderCatNav(); renderGrid();
  var top = $('bbCatalogue').getBoundingClientRect().top + window.scrollY - 96;
  window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
}

var savedScroll = 0;
function openSearch(entry){
  savedScroll = window.scrollY;
  state.query = ''; $('bbSearchInput').value = '';
  $('bbSearchOv').classList.add('show');
  track('search_started', { entry: entry });
  renderSearch();
  $('bbSearchInput').focus();
}
$('bbSearchOpen').addEventListener('click', function(){ openSearch('bar'); });
$('bbSearchOpen2').addEventListener('click', function(){ openSearch('sticky'); });
$('bbSearchClose').addEventListener('click', function(){
  $('bbSearchOv').classList.remove('show');
  window.scrollTo({ top: savedScroll });
});
$('bbSearchInput').addEventListener('input', function(){ state.query = this.value; renderSearch(); });

$('bbCartBar').addEventListener('click', openSheet);
$('bbHeaderCart').addEventListener('click', openSheet);
$('bbSheetClose').addEventListener('click', closeSheet);
$('bbDim').addEventListener('click', closeSheet);
$('bbConfirmOpen').addEventListener('click', openConfirmFlow);
$('bbConfirmBack').addEventListener('click', function(){ $('bbConfirmOv').classList.remove('show'); });
$('bbAddrBack').addEventListener('click', function(){ $('bbAddrOv').classList.remove('show'); });
$('bbAddrSave').addEventListener('click', saveAddress);
$('cfChange').addEventListener('click', function(){ $('bbConfirmOv').classList.remove('show'); openAddress(); });
$('bbPayBtn').addEventListener('click', startPayment);
$('bbRetry').addEventListener('click', function(){
  if (window.bbPendingVerify){ window.bbPendingVerify(); return; }
  $('bbFailOv').classList.remove('show');
  renderConfirm(); $('bbConfirmOv').classList.add('show');
});
$('bbChangeMethod').addEventListener('click', function(){
  window.bbPendingVerify = null;
  $('bbFailOv').classList.remove('show');
  renderConfirm(); $('bbConfirmOv').classList.add('show');
});
$('bbUnavail').addEventListener('click', function(e){
  if (e.target.closest('a')) return;
  this.classList.toggle('open');
});
var wa = 'https://wa.me/' + (CFG.whatsapp || '').replace(/\D/g,'');
$('bbWa').href = wa; $('bbWa2').href = wa;

/* ---- sticky compact header ---- */
window.addEventListener('scroll', function(){
  var header = document.querySelector('.bb-header');
  var headerBottom = header.offsetTop + header.offsetHeight;
  $('bbSticky').classList.toggle('show', window.scrollY > headerBottom);
}, { passive: true });

/* ---- impressions ---- */
var seenImp = {};
if ('IntersectionObserver' in window){
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (!en.isIntersecting) return;
      var el = en.target;
      if (el.classList.contains('bb-hero') && !seenImp.hero){ seenImp.hero = true; track('campaign_impression', {}); }
    });
  }, { threshold: 0.4 });
  var heroEl = document.querySelector('.bb-hero');
  if (heroEl) io.observe(heroEl);
}

/* ---- boot ---- */
if (lsGet('bb_pending_sync', 0)){
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
    try{ localStorage.removeItem('bb_pending_sync'); }catch(e){}
    if (c && c.item_count === 0 && cartCount() > 0){
      track('order_completed', { source: 'cart_empty_heuristic', value: Math.round(cartTotal()/100) });
      state.usuals = Object.keys(state.cart).concat(state.usuals.filter(function(id){ return !state.cart[id]; })).slice(0,6);
      lsSet(LS.usuals, state.usuals);
      state.returning = true; lsSet(LS.ret, true);
      state.cart = {}; saveCart();
      renderAll();
    }
  }).catch(function(){});
}
track('home_view', { shelf_order: state.returning ? 'buyagain_first' : 'popular_first' });
renderAll();
if (cartCount()) revalidateCart().then(function(){ renderAll(); });
})();
